export default {
  props: {
    rounded: {
      type: Boolean,
      default: false,
    },
    slim: {
      type: Boolean,
      default: false,
    },
    stroked: {
      type: Boolean,
      default: false,
    },
    selected: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      hovered: false,
    };
  },
  computed: {
    classes() {
      return [
        this.themeType,
        this.rounded
          ? 'rounded'
          : null,
        this.slim
          ? 'slim'
          : null,
        this.stroked
          ? 'stroked'
          : null,
        this.selected
          ? 'is-selected'
          : null,
      ];
    },
  },
};
